const About = () => (
  <>
    <p>
      Attempt to create an an infinite generated world in three.js
    </p>
    <p>
      All the Code is aivailable on my <a href="https://github.com/nicolas-jaussaud/personajs">github</a>
    </p>
    <p>
      <strong>3D ressources:</strong>
    </p>
      <ul>
        <li><a href="https://www.cgtrader.com/free-3d-models/character/woman/low-9fd52c98-570a-424b-aa88-f1d9585b0269">Low-poly Girl</a> created by <a href="https://www.cgtrader.com/singleway">Razvan Savescu</a></li>
        <li><a href="https://www.cgtrader.com/free-3d-models/plant/other/blocky-trees-pack">Blocky Trees</a> by <a href="https://www.cgtrader.com/singleway">Razvan Savescu</a></li>
        <li><a href="https://free3d.com/3d-model/19-low-poly-buildings-974347.html">Low Poly Buildings</a> created by <a href="https://free3d.com/user/backlog_s">Backlog</a></li>
        <li><a href="https://free3d.com/3d-model/low-poly-car-40967.html">Low Poly Car</a> created by <a href="https://free3d.com/user/wufudufu">WufuDufu</a></li>
      </ul>
    <p>
      Character animations from <a href="https://www.mixamo.com">Mixamo</a>
    </p>
    <p>
      <strong>Sounds:</strong>
    </p>
    <ul>
      <li><a href="https://www.soundjay.com/footsteps/sounds/footsteps-4.mp3">footsteps</a> (modified)</li>
    </ul>
  </>
)

export { About as default }
